<template>
    <div class="edit-content video-content">
        <video-upload-ugc ref="videoUploadRef" @addfile="addVideoFile" @delVideo="initVideo" @completed="videoCompleted"
            @videoTime="getVideoTime"></video-upload-ugc>
        <!-- 视频内容可编辑区域[[ -->
        <div class="video-text-content" v-show="hasVideo">
            <game-list ref="gameList" @gameChange="choiceGame"></game-list>
            <div class="title">
                <input v-model.trim="params.articleTitle" type="text" class="title-textarea" rows="1"
                    maxlength="30" placeholder="请输入标题内容（10~30个字以内）">
                <span class="wordsNum">{{titleLength}}/30</span>
                <!-- 7.5修改 -->
                <!-- 错误提示 -->
                <p class="error-prompt" v-show="tips.title">标题至少10个字符</p>
            </div>
            <div class="tag-block">
                <div class="tag-group tag-group-lable">
                    <div class="tag" v-for="tag in tagList" :key="tag" v-show="tagList.length!=0">{{tag}}<i
                            class="ico-writing ico-delete" @click="removeTag(tag)"></i></div>
                    <!-- 输入内容按回车插入一个标签 start -->
                    <!-- <input type="text" class="input-tag" placeholder="请输入标签..."> -->
                    <input type="text" placeholder="每个标签限8个字，最多9个标签，多个标签用空格 或 Enter隔开" class="input-tag"
                        autocomplete="off" @keyup.enter="addInputTag" @keydown.space="addInputTag" @blur="addInputTag"
                        v-model="inputTag">
                    <!-- 输入内容按回车插入一个标签 end -->
                    <!-- <span class="tips">3-5个标签</span> -->
                    <!-- 错误提示 -->
                    <p class="error-prompt" v-show="tips.show">{{tips.content}}</p>
                </div>
                <div class="tag-group f-hide">
                    推荐标签：
                    <div class="tag recommend">小猪佩奇</div>
                    <div class="tag recommend">小猪佩奇</div>
                </div>
            </div>
            <div class="editor">
                <textarea class="video-inf" v-model.trim="params.summary" name="" maxlength="50" placeholder="填写简介（10-50个字符），有助于视频更好的曝光"></textarea>
                <!-- 错误提示 -->
                <p class="error-prompt" v-show="tips.summary">请填写简介（10-50个字符）</p>
            </div>
            <div class="title">
                <input v-model.number="params.duration" style="background: transparent;" type="text"
                    :disabled="videoDisable" class="title-textarea" rows="1" placeholder="视频时长">
                <span class="wordsNum">秒</span>
            </div>
            <div class="img-upload">
                <!-- 上传图片 -->
                <tgl-image-cloud-upload style="display: inline-block" btnId='pic2' :minWidth="640" :minHeight="360"
                    :isCrop="true" :maxSize="6*1024*1024" ref="imgUpload" @completed="imageUploadCompleted"
                    @deletePic="deletePic">
                    <template #text>
                        <div class="upload-text">点击上传封面图片</div>
                    </template>
                </tgl-image-cloud-upload>
                <div class="upload-tips">
                    上传高清、无二维码、无黑边的封面图、将获得更多推荐机会
                    <br>
                    支持最小尺寸640*360,最大6MB,格式为jpg／png的图片
                </div>
                <!-- 7.5修改 -->
                <!-- 错误提示 -->
                <p class="error-prompt" v-show="tips.cover">未上传封面图片</p>
            </div>
            <!-- 7.11添加 -->
            <div class="flow-reward" v-show="userIdentityData.flowUser.code">
                <i class="ico-writing" :class="params.isJoinFlow ? 'ico-checkbox-checked' : 'ico-checkbox'"
                    @click="params.isJoinFlow == 0 ? params.isJoinFlow=1 : params.isJoinFlow=0"></i>
                <p class="flow-reward-text f-inlineblock-top" @click="params.isJoinFlow == 0 ? params.isJoinFlow=1 : params.isJoinFlow=0">参与流量奖励（每月参与流量奖励的内容上限{{userIdentityData.flowUser.remain}}篇，您当月已投稿参与流量奖励的内容量为<span>{{userIdentityData.flowUser.join}}</span>篇）</p>
            </div>
            <div class="declaration">
                <i class="ico-writing" :class="params.isOriginal ? 'ico-checkbox-checked' : 'ico-checkbox'"
                    @click="params.isOriginal == 0 ? params.isOriginal=1 : params.isOriginal=0"></i>
                <div class="declaration-text" @click="params.isOriginal == 0 ? params.isOriginal=1 : params.isOriginal=0">声明原创（获得更高收益与曝光）</div>
                <i class="ico-writing ico-question"></i>
                <div class="g-tooltip declaration-tips">
                    <div class="g-tooltip-arrows-down"></div>
                    <div class="tooltip-content">
                        伪造原创声明，将损失您的信用分和收益哦
                    </div>
                </div>
            </div>
        </div>
        <!-- 视频内容可编辑区域]] -->
        <video-preview ref="videoPreview"></video-preview>
    </div>
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/contribute/contribute.scss';
.input-tag {
    line-height: 36px;
    width: 600px;
}
</style>
<script>
import gameList from 'Components/v4/dropdown/gamelist_v4';
// import videoUpload from 'Components/v4/upload/videoUpload_v4';
// import videoUploadCloud from 'Components/v4/upload/videoUploadCloud';
import videoUploadUgc from 'Components/v4/upload/videoUploadUgc';
import videoPreview from 'Components/v4/pop/video_preview';
import {
    SaveUgcVideo, SaveDraftUgcVideo, CmeCreatureContribute
} from 'Services/getData';
export default {
    data() {
        return {
            params: {
                id: '',             //	文章id	int	否	null	文章id
                draftId: '',        //	草稿id	int	否	null	草稿id
                gameId: '',         //	游戏id	int	是	null	游戏id
                articleTitle: '',   //	内容标题	string	是	null	内容标题
                videoId: '',        //	视频源文件id	int	是	null	上传视频对应附件表id
                videoName: '',      //	视频源文件名称	string	是	null	视频源文件名称
                tags: '',           //	标签	string	是	null	标签逗号分割,如："标签1,标签2"
                summary: '',        //	内容简介	string	是	“”	图文为空，视频必填
                coverImgId: '',     //	封面图对应附件id	int	是	null	封面图对应附件表的id
                isOriginal: 0,  //	是否原创	int	否	0	内容原创申明，1：勾选原创 0：没有勾选
                isJoinFlow: 0,     //	是否参与流量奖励	int	否	0	0:不参与 1：参与
                mediaInfo: '',      //	分发信息	string	是	null	格式：[{"accountId":123,"title":"xx","cover":"https://1.jpg"}, ..],若无智能编目title:"",cover:""
                duration: '',
                qcloudFileId: ''
            },
            hasVideo: false,
            tips: {
                title: false,
                summary: false,
                cover: false,
                //标签
                show: false,
                content: ''
            },
            inputTag: '',
            tagList: [],
            userIdentityData: {
                tglVerify: {},
                flowUser: {
                    code: ''
                }
            },
            coverUrl: '',
            open: true,
            videoDisable: true,
            edit_times: 0,
            total_sec: Date.now()
        }
    },
    components: {
        gameList,
        // videoUpload,
        videoPreview,
        // videoUploadCloud,
        videoUploadUgc
    },
    computed: {
        titleLength() {
            return this.params.articleTitle.length;
        }
    },
    mounted() {

    },
    methods: {
        getVideoTime(time) {
            if (!time) {
                this.videoDisable = false;
            } else {
                this.videoDisable = true;
            }
            this.params.duration = time;
        },
        resetPage() {
            this.params.id = '';
            this.params.draftId = '';
            this.params.gameId = '';
            this.params.articleTitle = '';
            this.params.videoId = '';
            this.params.qcloudFileId = '';
            this.params.videoName = '';
            this.params.tags = '';
            this.params.summary = '';
            this.params.coverImgId = '';
            this.params.isOriginal = 0;
            this.params.isJoinFlow = 0;
            this.params.mediaInfo = [];
            this.params.duration = '';
            this.tagList = [];
            this.$refs.gameList.deleteGame();
            this.$refs.imgUpload.deletePic();
            this.deletePic();
            this.delVideoFile();
        },
        getAuthInfo(selectMediaList, autoAuth) {
            // this.$emit();
            // this.$parent.selectMediaList
            if (!autoAuth) {
                this.$parent.selectMediaList.forEach((v, k) => {
                    v.title = this.params.articleTitle;
                    v.cover = this.coverUrl;
                    v.summary = this.params.summary;
                    // console.log(this.params.mediaInfo)
                    // let mediaInfo = {};
                    // // debugger
                    // mediaInfo.accountId = v.curAccount.id;
                    // if(autoAuth){
                    //     mediaInfo.title = '';
                    //     mediaInfo.cover = '';
                    // }else{
                    //     mediaInfo.title = v.title;
                    //     mediaInfo.cover = v.cover;
                    // }
                    // this.params.mediaInfo.push(mediaInfo);
                })
            }
        },
        async cmeContribute(cmeId) {
            // 云剪投稿
            const res = await CmeCreatureContribute({
                taskId: cmeId
            });
            let videoInfo = {};
            if (res.status == 200 && res.data.code == 0) {
                videoInfo = res.data.data;
            }
            this.$refs.videoUploadRef.videoId = videoInfo.id;
            this.$refs.videoUploadRef.completed(videoInfo.fileId);
            this.$refs.videoUploadRef.progressBar = 100;
            this.$refs.videoUploadRef.fileName = videoInfo.name;
            this.params.videoId = videoInfo.id;
            this.params.videoName = videoInfo.name;
            this.params.qcloudFileId = videoInfo.fileId;
            this.params.duration = parseInt(videoInfo.duration);
        },
        getDraft(data, auth) {
            this.params.draftId = data.id;
            this.params.gameId = data.content.gameId;
            if (data.content.gameId) {
                this.$refs.gameList.syncGameInfoWithId(this.params.gameId);
            }
            this.params.articleTitle = data.content.articleTitle;
            this.params.summary = data.content.summary;
            this.$refs.videoUploadRef.videoId = data.content.videoId;
            // this.$refs.videoUploadRef.uploadStatus = 3;
            this.$refs.videoUploadRef.completed(data.content.qcloudFileId);
            this.$refs.videoUploadRef.progressBar = 100;
            this.$refs.videoUploadRef.fileName = data.content.videoName;
            this.params.videoId = data.content.videoId;
            this.params.videoName = data.content.videoName;
            this.params.isJoinFlow = data.content.ugcProfitCheck;
            this.params.qcloudFileId = data.content.qcloudFileId;
            this.params.duration = data.content.duration;
            if (data.content.tags) {
                this.tagList = data.content.tags.split(',')
            }
            if (data.content.coverUrl) {
                this.params.coverImgId = data.content.coverImgId;
                this.$refs.imgUpload.uploadStatus = 3;
                this.$refs.imgUpload.setPic(data.content.coverUrl);
            }
            this.params.isOriginal = data.content.isOriginal;
            this.coverUrl = data.content.coverUrl;
        },
        cloneObj(obj) {
            //1 
            let newJsonObj = {};
            let items;

            newJsonObj = JSON.parse(JSON.stringify(obj));
            //2 
            for (items in obj) { if (typeof obj[items] == "function" || typeof obj[items] == "undefined" || obj[items] instanceof RegExp) { newJsonObj[items] = obj[items]; } }
            //3
            var newObj = new obj.constructor; for (items in newJsonObj) { newObj[items] = newJsonObj[items] }
            return newObj;
        },
        showPreview() {
            let data = this.cloneObj(this.params);
            data.creator = data.creator = this.$store.state.realUserInfo.userName;
            data.created = `${new Date().toLocaleDateString()} ${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`;
            data.summary = this.params.summary;
            data.articleType = 1;
            console.log(data)
            this.$refs.videoPreview.contributeInfo(data);
        },
        addInputTag() {
            let sTag = this.inputTag.replace(/^\s+|\s+$/g, "");
            if (sTag && sTag.length > 8) {
                this.tips = {
                    content: '单个标签不能超过8个字符哦~',
                    show: true
                }
                this.inputTag = '';
                return false;
            }
            if (this.tagList.includes(sTag)) {
                this.tips = {
                    content: '存在重复的标签哦~',
                    show: true
                }
                this.inputTag = '';
                return false;
            }
            if (sTag) {

                if (this.tagList.length > 8) {
                    this.tips = {
                        content: '最多输入9个标签哦~',
                        show: true
                    }
                } else {
                    this.tagList.push(sTag);
                    this.tips.show = false;
                }
            }
            this.inputTag = '';
        },
        removeTag(tag) {
            let index = this.tagList.indexOf(tag);
            this.tagList.splice(index, 1);
            this.tips.show = false;
        },
        choiceGame(game) {
            // console.log(game)
            if (game) {
                this.params.gameId = game.id;
            } else {
                this.params.gameId = '';
            }
        },
        videoCompleted(result) {
            this.params.videoId = result.videoId;
            this.params.qcloudFileId = result.qcloudFileId;
            this.params.videoName = result.fileName;
        },
        addVideoFile(uploader) {
            this.hasVideo = true;
            this.$emit('videoPublish');
        },
        delVideoFile() {
            this.$refs.videoUploadRef.delVideo();
        },
        initVideo() {
            this.params.videoId = '';
            this.params.qcloudFileId = '';
            this.params.videoName = '';
            this.hasVideo = false;
            this.$emit('delVideo');
        },
        imageUploadCompleted(data) {
            this.params.coverImgId = data.id;
            this.coverUrl = data.url;
        },
        deletePic() {
            this.params.coverImgId = '';
            this.coverUrl = '';
        },
        getParams(selectMediaList, autoAuth) {
            this.params.mediaInfo = [];
            selectMediaList.forEach((v, k) => {
                console.log(this.params.mediaInfo)
                let mediaInfo = {};
                mediaInfo.accountId = v.curAccount.id;
                if (autoAuth) {
                    mediaInfo.title = '';
                    mediaInfo.cover = '';
                    mediaInfo.summary = '';
                } else {
                    mediaInfo.title = v.title;
                    mediaInfo.cover = v.cover;
                    mediaInfo.summary = v.summary;
                }
                this.params.mediaInfo.push(mediaInfo);
            })
            this.params.mediaInfo = JSON.stringify(this.params.mediaInfo);
        },
        paramHasSet() {
            this.params.tags = this.tagList.join(',');
            return this.params;
        },
        async saveDraft(selectMediaList, autoAuth) {
            this.getParams(selectMediaList, autoAuth);
            this.params.tags = this.tagList.join(',');
            if (this.open) {
                this.open = false;
                let res = await SaveDraftUgcVideo(this.params);
                this.open = true;
                if (res.data.code == 0) {
                    this.params.draftId = res.data.data.draftId;
                    this.$alert('保存成功');
                }
            }
        },
        async publish(selectMediaList, autoAuth) {
            this.edit_times++;
            this.getParams(selectMediaList, autoAuth);

            if (!this.params.gameId) {
                this.$alert("请选择游戏");
                return false;
            }
            this.params.articleTitle = this.params.articleTitle.replace(/\s/g, '');
            if (!this.params.articleTitle || this.titleLength < 10) {
                this.tips.title = true;
                this.$alert('标题至少10个字符~')
                return false;
            }

            this.params.tags = this.tagList.join(',');
            if (!this.params.tags) {
                this.tips.show = true;
                this.$alert('标签不能为空');
                return false;
            }
            if (this.params.summary.length < 10 || this.params.summary.length > 50) {
                this.$alert('请填写简介（10-50个字符）')
                this.tips.summary = true;
                return false;
            }
            if (!this.params.coverImgId) {
                this.tips.cover = true;
                this.$alert("未上传封面图片");
                return false;
            }
            // if(this.params.mediaInfo.length<=2){
            //     this.$alert("请选择渠道");
            //     return false;
            // }
            if (this.open) {
                let reqStartTime = Date.now();
                this.open = false;
                let res = await SaveUgcVideo(this.$qs.stringify(this.params));
                this.open = true;
                this.$common.reportContribute(
                    res.data.code == 0 ? 1 : 0,
                    res.data.info,
                    this.edit_times,
                    'ugc',
                    reqStartTime,
                    this.total_sec,
                );
                if (res.data.code == 0) {
                    this.params.id = res.data.data.id;
                    this.$alert('发布成功', '操作', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$router.push({
                                name: 'v4-manage-content'
                            })
                        }
                    });
                }
            }
        }
    },
    watch: {
        "params.articleTitle": function () {
            this.tips.title = false;
        },
        "params.summary": function () {
            this.tips.summary = false;
        },
        "params.coverImgId": function () {
            this.tips.cover = false;
        }
    }
}
</script>